import { useEffect, useState } from "react";
import './LegalApp.css';
import Navbar from './Navbar';
import StarRating from "./StarRating";

const Rights = () => {
    const [rightsData, setRightsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [currentFAQ, setCurrentFAQ] = useState([]);

    //const API_URL = 'http://localhost:8080';
    const API_URL = 'https://legalapp-638589756238.asia-south1.run.app';

    const openPopup = (faq) => {
        setCurrentFAQ(faq);
        setShowPopup(true);
    };

    const closePopup = () => {
        setShowPopup(false);
        setCurrentFAQ([]);
    };

    useEffect(() => {
    document.body.style.backgroundColor = "white";
    }, []);

    useEffect(() => {
        // Simulating an API call
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await fetch(API_URL + "/rights"); // Replace with actual API URL
                const data = await response.json();
                setRightsData(data);
            } catch (error) {
                console.error("Error fetching rights data:", error);
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <div className="fir-page-container">
            <Navbar />

            <div className="page-content">
                {loading ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <div className="rights-list-container">
                        <br></br><br></br>
                        <h2>Legal Rights</h2>
                        <ul className="rights-list">
                            {Array.from(new Set(rightsData.map(right => right.title))).map((title, index) => (
                                <li key={index}>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedTitle(title);
                                    }}>
                                        {title}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {selectedTitle && (
                            <div className="rights-details">
                                <h3>{selectedTitle}</h3>
                                {rightsData.filter(right => right.title === selectedTitle).map((right, index) => (
                                    <div key={index} className="right-item">
                                        <p><b>Description:</b> {right.description}</p>
                                        {right.legalProvisions && right.legalProvisions.length > 0 && (
                                            <p><b>Legal Provisions:</b> {right.legalProvisions.map(lp => `Section ${lp.section} ${lp.act}`).join(", ")}</p>
                                        )}
                                        {right.remedy && <p><b>Remedy:</b> {right.remedy}</p>}
                                        {right.citations && right.citations.length > 0 && (
                                            <p><b>Judgments:</b> {right.citations.map(j => j.title + ' ' + j.caseCitation + ' (' + j.court + ')').join(", ")}</p>
                                        )}
                                        {right.questionsAnswers && right.questionsAnswers.length > 0 && (
                                            <p><b>FAQ:</b> <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                // alert(`FAQ:\n${right.questionsAnswers.map(qa => `${qa.question}\n${qa.answer}`).join("\n\n")}`);
                                                openPopup(right.questionsAnswers);
                                            }}>View FAQ</a></p>
                                        )}
                                        {/* <p><b>Author:</b> {right.createdBy}</p> */}
                                        <StarRating rating='4.95' reviewCount='49671' />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <h3>Frequently Asked Questions</h3>
                        <ul>
                            {currentFAQ.map((faq, index) => (
                                <li key={index}>
                                    <b>Q: {faq.question}</b>
                                    <p>
                                        {
                                            faq.answer.split('\n').map((line, index) => (
                                                <span key={index}>
                                                    {line}
                                                    <br />
                                                </span>
                                            ))
                                        }
                                    </p>
                                </li>
                            ))}
                        </ul>
                        <button onClick={closePopup}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Rights;
